import { useEffect, useState } from "react";

const KEY = "orbit_kiosk";
const EVT = "app:kiosk";

if (typeof window !== "undefined") {
  const q = new URLSearchParams(window.location.search);
  if (q.get("kiosk") === "1") { localStorage.setItem(KEY, "1"); q.delete("kiosk"); const u = new URL(window.location.href); u.search = q.toString(); window.history.replaceState(null, "", u.toString()); }
}

export const isKiosk = () => localStorage.getItem(KEY) === "1";
export const setKiosk = (on) => { localStorage.setItem(KEY, on ? "1" : "0"); window.dispatchEvent(new Event(EVT)); };
export const isKioskUnlocked = () => sessionStorage.getItem("orbit_kiosk_unlocked") === "1";
export const unlockKiosk = () => { sessionStorage.setItem("orbit_kiosk_unlocked", "1"); window.dispatchEvent(new Event(EVT)); if (document.fullscreenElement) document.exitFullscreen?.().catch(() => {}); };
export const relockKiosk = () => { sessionStorage.removeItem("orbit_kiosk_unlocked"); window.dispatchEvent(new Event(EVT)); enterFullscreen(); };
export const enterFullscreen = () => { if (!document.fullscreenElement) document.documentElement.requestFullscreen?.({ navigationUI: "hide" }).catch(() => {}); };

export function useKiosk() {
  const [, tick] = useState(0);
  useEffect(() => { const h = () => tick((x) => x + 1); window.addEventListener(EVT, h); return () => window.removeEventListener(EVT, h); }, []);
  return { kiosk: isKiosk(), locked: isKiosk() && !isKioskUnlocked() };
}
